module.exports = __webpack_public_path__ + "img/login_white_middle.9275981e.png";